/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  function handleFreeGiftsB2B(detail) {
    if (!detail || !detail.cart || !detail.cart.cart) { 
      return;
    }

    // Ensure detail and cart are defined
    const cartSubtotal = detail.cart.cart.items_subtotal_price;

    const cartSubtotalValue = parseInt(cartSubtotal) || 0;
    let currentCartValue = cartSubtotalValue / 100;

    // If B2B
    if(document.body.hasAttribute('data-b2b')) {
      const lang = document.documentElement.lang;
      let divisor = 1;
      if (lang === 'de') divisor = 1;

      currentCartValue = currentCartValue / divisor;
    }

    const selectors = {
      rebuyCartProgress: "[data-rebuy-component='progress-bar']",
      b2bFreeGiftContainer: ".rebuy-cart__b2b-free-gift"
    };

    // Tjek om kunden er B2B
    const isB2B = document.body.hasAttribute('data-b2b');
    if (!isB2B) return;

    // Check if customer has B2B_FREE_GIFTS tag
    const customerTags = window.theme.settings.customerTags || [];
    const hasB2bFreeGiftsTag = customerTags.includes('B2B_FREE_GIFTS');

    const progressBar = document.querySelector(selectors.rebuyCartProgress);

    if (!progressBar) {
      console.warn("Progress bar not found");
      return;
    }

    if (!hasB2bFreeGiftsTag) {
      progressBar.style.display = 'none';
      return;
    };

    // Fjern tidligere hvis der er en
    const existingContainer = progressBar.querySelector(selectors.b2bFreeGiftContainer);
    if (existingContainer) {
      existingContainer.remove();
    }

    // Hent korrekt produkt info
    const enabled = window.theme.settings.b2bFreeGiftEnabled == true || false;

    if (!enabled) return;

    const productImage = window.theme.settings.b2bFreeGiftProductImage;
    const productTitle = window.theme.settings.b2bFreeGiftProductTitle;

    if (!productImage || !productTitle) {
      console.warn("B2B product info mangler");
      return;
    }

    progressBar.classList.add('gift');

    // --- B2B Free Gift Threshold Logic ---
    // Example: window.b2bFreeProductTiers = '[{"min_value":"2.000","max_value":"2.999","label":"0,5 KG"}, ...]';
    function parseNumber(str) {
      return parseInt(str.replace(/\./g, ''), 10);
    }

    let tiers = [];
    try {
      tiers = window.b2bFreeProductTiers.map(tier => ({
        min: parseNumber(tier.min_value),
        max: tier.max_value ? parseNumber(tier.max_value) : Infinity,
        label: tier.label
      }));
    } catch (e) {
      console.warn('B2B tiers parsing failed', e);
      return;
    }

    // Find current and next tier
    let currentTier = null, nextTier = null;
    for (let i = 0; i < tiers.length; i++) {
      if (currentCartValue >= tiers[i].min && currentCartValue <= tiers[i].max) {
        currentTier = tiers[i];
        nextTier = tiers[i + 1] || null;
        break;
      }
      if (currentCartValue < tiers[i].min) {
        nextTier = tiers[i];
        break;
      }
    }
    if (!currentTier && currentCartValue > tiers[tiers.length - 1].max) {
      currentTier = tiers[tiers.length - 1];
    }

    // Get template strings from window variables
    const b2b_gift_title = window.theme.settings.b2bFreeGiftTitle || 'Gratis smagsprøve';
    const current_label_template = window.theme.settings.b2bCurrentLabel || 'Bestilling over {current_min_threshold} kr.';
    const remaining_label_template = window.theme.settings.b2bRemainingLabel || 'Bestil for {remaining_amount} kr. og få {prize} gratis!';
    const reached_label_template = window.theme.settings.b2bReachedLabel || 'Du har opnået den maksimale gave!';

    const progressWrapper = progressBar.querySelector('.rebuy-cart__progress-bar-wrapper');
    const progressPrompt = progressBar.querySelector('#rebuy-cart__progress-bar-meter-label');

    if (progressWrapper) progressWrapper.style.display = 'none';
    if (progressPrompt) progressPrompt.style.display = 'none';

    // Set variables for text replacements
    const lang = document.documentElement.lang;
    const locale = lang === 'de' ? 'de-DE' : 'da-DK';
    
    const current_min_threshold = currentTier ? currentTier.min.toLocaleString(locale) : (tiers.length ? tiers[0].min.toLocaleString(locale) : '');
    
    // Format remaining_amount with proper decimal handling
    let remaining_amount = '';
    if (nextTier) {
      const remainingValue = nextTier.min - currentCartValue;
      let formatted = remainingValue.toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      
      // Remove trailing zeros if it's a whole number
      if (formatted.endsWith(',00') || formatted.endsWith('.00')) {
        formatted = formatted.replace(/([,.]00)$/, '');
      }
      
      remaining_amount = formatted;
    }
    
    const prize = nextTier ? nextTier.label : '';
    const current_label = currentTier ? currentTier.label : (tiers.length ? tiers[0].label : '');

    // Build text using templates
    const currentThresholdText = current_label_template.replace('{current_min_threshold}', current_min_threshold);
    let thresholdProgressText = '';
    if (!nextTier && currentTier && currentCartValue >= currentTier.min) {
      // Last tier completed
      thresholdProgressText = reached_label_template;
    } else if (nextTier) {
      thresholdProgressText = remaining_label_template
        .replace('{remaining_amount}', remaining_amount)
        .replace('{prize}', prize);
    }

    // Console log the results
    // console.log('currentThresholdText:', currentThresholdText);
    // console.log('thresholdProgressText:', thresholdProgressText);
    // console.log('current_label:', current_label);

    // You can now use currentThresholdText and thresholdProgressText to update the HTML as needed.
      // Lav container
    const freeGiftContainer = document.createElement("div");
    freeGiftContainer.classList.add(selectors.b2bFreeGiftContainer.replace(".", ""));

    // Byg HTML
    freeGiftContainer.innerHTML = `
    <div class="b2b-gift-wrapper">
      <div class="b2b-gift-inner">
        <p class="gift-titel">${b2b_gift_title}</p>
        <p class="gift-description">${thresholdProgressText}</p>
      </div>
      <div class="b2b-gift-info-wrapper">
        <img src="${productImage}" alt="${productTitle}" class="gift-product-img" style="width: 70px; height: 70px; border-radius: 18px;">
        <div class="b2b-gift-info-inner">
        <span class="gift-product-threshold">${currentThresholdText}</span>
        <span class="gift-product-info">${productTitle}</span>
        <span class="gift-product-price">${current_label}</span>
        </div>
      </div>

    </div>
    `;

    // Indsæt øverst
    progressBar.prepend(freeGiftContainer);
  }

  function showPaymentIcons() {
    setTimeout(() => {
      const paymentIcons = document.querySelector(".cart__drawer__payment__icons");
      const checkoutArea = document.querySelector('div[data-rebuy-component="checkout-area"]');
  
      if (!paymentIcons || !checkoutArea || checkoutArea.querySelector(".cloned-payment-icons")) {
        return;
      }
  
      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      clonedPaymentIcons.classList.add("cloned-payment-icons"); 
      checkoutArea.appendChild(clonedPaymentIcons);
    }, 500);
  }

  function showShipping() {
    const alreadyAdded = document.querySelector(".cloned-shipping-price");
    if (alreadyAdded) {
      return;
    }

    const shippingText = document.querySelector(".shipping-price");
    const checkoutArea = document.querySelector('div[data-rebuy-component="cart-subtotal"]');


    if (!shippingText || !checkoutArea) {
      // Prøv igen senere, hvis DOM'en ikke er klar endnu
      setTimeout(showShipping, 300);
      return;
    }
    const clonedShippingText = shippingText.cloneNode(true);
    clonedShippingText.classList.add("cloned-shipping-price");
    checkoutArea.appendChild(clonedShippingText);
  }

  function formatPrices() {
    const priceElementSelectors = [
      "#rebuy-cart .rebuy-money span:last-child", 
      "#rebuy-cart .rebuy-cart__flyout-subtotal-amount span:last-child",
      "#rebuy-cart .rebuy-cart__flyout-subtotal-final-amount span:last-child",
      "#rebuy-cart .rebuy-cart__flyout-subtotal-compare-amount span:last-child"
    ];

      setInterval(() => {
        const lang = document.documentElement.lang;
        const isB2B = document.body.hasAttribute('data-b2b');
        
        // Opsæt valuta og divisor pr. land
        let currencySymbol = 'kr';
        let divisor = 1;
        let locale = 'da-DK';
    
        if (lang === 'de') {
          currencySymbol = '€';
          divisor = 1;
          locale = 'de-DE';
        }
    
        // Regex matcher: kr 1.000,00 | 1.000,00 kr | €3,81 | 3,81€
        const priceRegex = /(?:kr|€)?\s*([\d.,]+)\s*(kr|€)?/gi;
    
        priceElementSelectors.forEach(selector => {
          document.querySelectorAll(selector).forEach(element => {
            if (!element.querySelector('span')) {
              const text = element.textContent;
              if ((text.includes('kr') || text.includes('€')) && !text.trim().endsWith(`${currencySymbol}.`)) {
                if (priceRegex.test(text)) {
                  const newText = text.replace(priceRegex, (match, price, suffixSymbol) => {
                    let updatePrice = price;
    
                    if (isB2B) {
                      const priceNum = parseFloat(updatePrice.replace(/\./g, '').replace(/\,/g, '.'));
                      const net = priceNum / divisor;
    
                      let formatted = net.toLocaleString(locale, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      });
    
                      // Fjern ",00" eller ".00" hvis det er rent beløb
                      if (formatted.endsWith(',00') || formatted.endsWith('.00')) {
                        formatted = formatted.replace(/([,.]00)$/, '');
                      }
    
                      updatePrice = formatted;
                    }
    
                    return `${updatePrice} ${currencySymbol}.`;
                  });
    
                  element.textContent = newText;
                }
              }
            }
          });
        });
    
        // Progress bar tekst (samme logik)
        const progressElement = document.querySelector("#rebuy-cart .rebuy-cart__progress-bar-prompt");
        if (progressElement) {
          const text = progressElement.textContent;
          if ((text.includes('kr') || text.includes('€')) && progressElement.dataset.lastFormatted !== text) {
            const newText = text.replace(priceRegex, (match, price) => {
              return `${price} ${currencySymbol}.`;
            });
            progressElement.textContent = newText;
            progressElement.dataset.lastFormatted = newText;
          }
        }
      }, 30);
  }

  function updateCartCount(cart) {
    if(!cart) return;
    const headerCartStatuses = document.querySelectorAll('.header__cart__status');
    if (headerCartStatuses && headerCartStatuses.length > 0) {
      headerCartStatuses.forEach(__ => __.textContent = cart.item_count);
    }
  }

  document.addEventListener("rebuy:smartcart.ready", (event) => {
    formatPrices();

    setTimeout(() => {
      handleFreeGiftsB2B(event.detail);
      showPaymentIcons();
      showShipping();      
    }, 700);

  });

  document.addEventListener("rebuy:cart.change", (event) => {
    updateCartCount(event.detail.cart.cart);

    setTimeout(() => {
      handleFreeGiftsB2B(event.detail);
      showPaymentIcons();
      showShipping();
    }, 700);
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

// --- Minimal B2B Net Price Patch for Product Grid and Product Page ---
// This script divides the price ONCE for B2B customers (DK: /1.25, DE: /1.19) for grid and product page prices.
// It never touches B2C prices, never double-applies, and leaves labels/translations untouched.
(function() {
  function patchB2BPrices() {
    if (!document.body.hasAttribute('data-b2b')) return;

    const lang = document.documentElement.lang;
    let divisor = 1;
    if (lang === 'de') divisor = 1;

    // All selectors where B2B price patch should be applied
    const priceSelectors = [
      '.product-item__price .new-price', // grid
      '.product__price-display [data-product-price]', // product page
      '.predictive-search__products__list .new-price' // predictive search
    ];

    priceSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (el.dataset.b2bPatched === 'true') return;
        el.dataset.b2bPatched = 'true';

        const match = el.textContent.match(/([\d\.,]+)/);
        if (!match) return;

        let priceStr = match[1].replace(/\./g, '').replace(/\,/g, '.');
        let priceNum = parseFloat(priceStr);

        if (isNaN(priceNum) || priceNum === 0) return;

        let net = priceNum / divisor;
        // if (Math.abs(priceNum - Math.round(net)) < 1) return; // COMMENTED OUT - NOT SURE WHAT IT DOES?


        let formatted = net.toLocaleString(lang === 'de' ? 'de-DE' : 'da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        if (formatted.endsWith(',00') || formatted.endsWith('.00')) {
          formatted = formatted.replace(/([,.]00)$/, '');
        }

        el.textContent = el.textContent.replace(match[1], formatted);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', patchB2BPrices);
  document.addEventListener('shopify:section:load', patchB2BPrices);
  setTimeout(patchB2BPrices, 1000);

  // On page load, add an interval to ruun it in a 10ms interval to find new price elements
  setInterval(patchB2BPrices, 100);
})();

